// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-overlay-container {
  contain: layout;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  display: contents;
}

:where(.vuetify-styles) .v-overlay-scroll-blocked {
  padding-inline-end: var(--v-scrollbar-offset);
}
:where(.vuetify-styles) .v-overlay-scroll-blocked:not(html) {
  overflow-y: hidden !important;
}
:where(.vuetify-styles) html.v-overlay-scroll-blocked {
  position: fixed;
  top: var(--v-body-scroll-y);
  left: var(--v-body-scroll-x);
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-overlay {
  --v-overlay-opacity: 0.32;
  border-radius: inherit;
  display: flex;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
}

:where(.vuetify-styles) .v-overlay__content {
  outline: none;
  position: absolute;
  pointer-events: auto;
  contain: layout;
}

:where(.vuetify-styles) .v-overlay__scrim {
  pointer-events: auto;
  background: #000;
  border-radius: inherit;
  bottom: 0;
  left: 0;
  opacity: var(--v-overlay-opacity);
  position: fixed;
  right: 0;
  top: 0;
}

:where(.vuetify-styles) .v-overlay--absolute {
  position: absolute;
}

:where(.vuetify-styles) .v-overlay--contained .v-overlay__scrim {
  position: absolute;
}

:where(.vuetify-styles) .v-overlay--scroll-blocked {
  padding-inline-end: var(--v-scrollbar-offset);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VOverlay/VOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,iCAAiC;EACjC,eAAe;EACf,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".v-overlay-container {\n  contain: layout;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  display: contents;\n}\n\n.v-overlay-scroll-blocked {\n  padding-inline-end: var(--v-scrollbar-offset);\n}\n.v-overlay-scroll-blocked:not(html) {\n  overflow-y: hidden !important;\n}\nhtml.v-overlay-scroll-blocked {\n  position: fixed;\n  top: var(--v-body-scroll-y);\n  left: var(--v-body-scroll-x);\n  width: 100%;\n  height: 100%;\n}\n\n.v-overlay {\n  --v-overlay-opacity: 0.32;\n  border-radius: inherit;\n  display: flex;\n  left: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.v-overlay__content {\n  outline: none;\n  position: absolute;\n  pointer-events: auto;\n  contain: layout;\n}\n\n.v-overlay__scrim {\n  pointer-events: auto;\n  background: #000;\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  opacity: var(--v-overlay-opacity);\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n\n.v-overlay--absolute {\n  position: absolute;\n}\n\n.v-overlay--contained .v-overlay__scrim {\n  position: absolute;\n}\n\n.v-overlay--scroll-blocked {\n  padding-inline-end: var(--v-scrollbar-offset);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
